import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addParent, blockUnblockParent, deleteParent, editParent, parentListing, viewParent } from "../apis/apiHandler";

export const allParents = createAsyncThunk(
    'parent/list',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await parentListing(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const addParents = createAsyncThunk(
    'parent/add',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await addParent(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const editParents = createAsyncThunk(
    'parent/edit',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await editParent(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const viewParentDetails = createAsyncThunk(
    'parent/view',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await viewParent(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const deleteParents = createAsyncThunk(
    'parent/delete',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await deleteParent(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const changeParentStatus = createAsyncThunk(
    'parent/status',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await blockUnblockParent(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

const initialState = {
    loading: false,
    parentList: [],
    error: null,
    addSuccess: false,
    editSuccess: false,
    parentDetail: {},
    deleteSuccess: false,
    statusSuccess: false
};

const parentSlice = createSlice({
    name: 'parent',
    initialState,
    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(allParents.pending, (state) => {
                state.loading = true;
            })
            .addCase(allParents.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.parentList = payload?.data;
            })
            .addCase(allParents.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(addParents.pending, (state) => {
                state.loading = true;
                state.addSuccess = false;
                state.error = null;
            })
            .addCase(addParents.fulfilled, (state) => {
                state.loading = false;
                state.addSuccess = true;
            })
            .addCase(addParents.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.addSuccess = false;
            })
            .addCase(editParents.pending, (state) => {
                state.loading = true;
                state.editSuccess = false;
                state.error = null;
            })
            .addCase(editParents.fulfilled, (state) => {
                state.loading = false;
                state.editSuccess = true;
            })
            .addCase(editParents.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.editSuccess = false;
            })
            .addCase(viewParentDetails.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(viewParentDetails.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.parentDetail = payload?.data;
            })
            .addCase(viewParentDetails.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(deleteParents.pending, (state) => {
                state.loading = true;
                state.deleteSuccess = false;
                state.error = null;
            })
            .addCase(deleteParents.fulfilled, (state) => {
                state.loading = false;
                state.deleteSuccess = true;
            })
            .addCase(deleteParents.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.deleteSuccess = false;
            })
            .addCase(changeParentStatus.pending, (state) => {
                state.loading = true;
                state.statusSuccess = false;
                state.error = null;
            })
            .addCase(changeParentStatus.fulfilled, (state) => {
                state.loading = false;
                state.statusSuccess = true;
            })
            .addCase(changeParentStatus.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.statusSuccess = false;
            })
    }
})

export default parentSlice.reducer;